export default __webpack_public_path__ + "static/media/close.f91a5ce2.svg";